// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__xpAZR","wrapper":"styles_wrapper__PE7kx","text":"styles_text__M80+P"};